var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "border-bleu",
      class: _vm.isBlack ? "bg-gray1" : "bg-gray2",
    },
    [
      _vm._l(_vm.claim.attributes, function (attribute, index) {
        return [
          _c(
            "div",
            {
              key: index,
              staticClass: "d-flex align-items-center justify-content-start",
            },
            [
              _c("span", {
                staticClass: "small claim-text",
                domProps: { innerHTML: _vm._s(attribute.text) },
              }),
            ]
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }